import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import DashboardWaveSvg from "../../common/DashboardWaveSvg";
import { DashBoardHeaderCardColors } from "../../../utils/constants";
import GoToIcon from "../../IconComp/goToIcon";
import { BorderAll } from "@mui/icons-material";
interface IProps {
  title: string;
  value: number | string;
  Image: any;
  color: any;
  rating?: number | undefined;
  title2?: string | undefined;
  value2?: string | undefined | number;
  value3?: string | undefined | number;
  title3?: string | undefined;
  textColor?: any | undefined;
  textColor1?: any | undefined;
  button?: any;
  onClick?: () => void;
}
const HeaderItem = ({
  title,
  value,
  Image,
  color,
  //title2,
  title3,
  //value2,
  value3,
  textColor,
  textColor1,
  button,
  onClick,
}: IProps) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
          borderRadius: "5px",
          pt: 2,
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img src={Image} alt="title" />
        </Box>

        <Box
          sx={{
            display: "flex",
            color: "Black",
            alignItems: "center",
            //px: 5,
            //pt: 2,
          }}
        >
          <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>{value}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "Black",
            flexDirection: "row",
            alignItem: "center",
            //px: 2,
            //pt: 1,
            fontSize: "12px",
            fontWeight: 500,
          }}
        >
          <Typography
            sx={{ fontSize: "16px", fontWeight: 500 }}
          >
            {title}
          </Typography>
        </Box>
        {button && (
          <Box
            sx={{
              backgroundColor: DashBoardHeaderCardColors.medShortage.secondary,
              cursor: "pointer",
              width: "100%",
              mt: 1,
              borderTop: "1px solid #F0483E",
              textAlign: "center",
            }}
            onClick={onClick}
          >
            {button}
          </Box>
        )}
      </Box>
    </>
  );
};

export default HeaderItem;
